$(document).on("turbolinks:load",function(){
  $(".face_box").click(function() {
    $(this).siblings('rect').attr('selected',null);
    $(this).attr("selected","selected");
    $(this).closest('form').find('input#imove_request_image_id_attributes_selected_face').val($(this).attr('position'));
  });
});